module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lance-input-container"
  }, [_c('label', [_vm._v("Alterar tempo:")]), _vm._v(" "), _c('div', {
    staticClass: "pos-rlt"
  }, [_c('input', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['f9']),
      expression: "['f9']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valor),
      expression: "valor"
    }],
    ref: "input",
    staticClass: "lance-input no-shortkey",
    attrs: {
      "type": "number",
      "placeholder": "10"
    },
    domProps: {
      "value": (_vm.valor)
    },
    on: {
      "shortkey": _vm.focusMe,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.alterar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valor = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "shoutcut"
  }, [_vm._v("F9")])]), _vm._v(" "), _c('u-button', {
    staticClass: "lance-btn",
    on: {
      "click": _vm.alterar
    }
  }, [_vm._v("OK")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd8bff60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/InputAlterarTimer.vue
// module id = 856
// module chunks = 2